<template>
  <div class="edit-hours">
    <!-- <div class="block"> -->
      <h1 class="title is-5">{{ name }}</h1>
      <h2 v-if="dateStr.length" class="subtitle is-6">
        <b-tag v-if="sickDay" type="is-success">
          <strong>{{ dateStr }} -  SICK</strong> <a v-if="!inputsDisabled" @click.prevent="sickDay = false" class="delete is-small"></a>
        </b-tag>
        <b-tag v-else-if="leaveDay" type="is-info">
          <strong>{{ dateStr }}  - LEAVE</strong> <a v-if="!inputsDisabled" @click.prevent="leaveDay = false" class="delete"></a>
        </b-tag>
        <b-tag v-else type="is-white">
          <strong>{{ dateStr }}</strong>
        </b-tag>
      </h2>
    <!-- </div> -->

    <template v-if="futureDay">
      <div class="notification is-warning">
        <strong>WARNING:</strong> Cannot enter hours for a future day.
      </div>
    </template>

    <template v-else>

      <div class="columns is-mobile">

        <!-- START -->
        <div class="column">
          <div class="field">
            <label class="label">
              <i class="far fa-clock"></i> Start
              <span v-if="showStartNow && !inputsDisabled" class="now has-text-info" @click="startTimestamp = getNow()">now</span>
            </label>
            <time-input v-model="startTimestamp" :date="day.timestamp" :am="true" :disabled="inputsDisabled"></time-input>
          </div>
        </div>

        <!-- END -->
        <div class="column">
          <div class="field">
            <label class="label">
              <i class="far fa-clock"></i> End
              <span v-if="showEndNow && !inputsDisabled" class="now has-text-info" @click="endTimestamp = getNow()">now</span>
            </label>
            <time-input v-model="endTimestamp" :date="day.timestamp" :pm="true" :disabled="inputsDisabled" :valid="!endTimestamp || endTimestamp > startTimestamp"></time-input>
          </div>

        </div>
      </div>

      <div class="columns is-mobile">
        <div class="column">
          <div class="field is-grouped">
            <p class="control">
              <b-checkbox v-model="hadBreak" :disabled="inputsDisabled">Lunch</b-checkbox>
            </p>
            <p class="control is-expanded">
              <input v-if="hadBreak" class="input" v-model="breakMinutes" type="number" placeholder="mins" pattern="[0-9]*" :disabled="inputsDisabled">
            </p>
          </div>
        </div>
        <div class="column"></div>
      </div>

      <div class="columns is-mobile has-text-centered">
        <div class="column">
          <p class="heading">HOURS</p>
          <p class="title"><pretty-time :show-zero="true" :seconds="seconds" /></p>
        </div>
        <div class="column">
          <p class="heading">OVERTIME</p>
          <p class="title">
            <span class="overtime-button hoverable" :class="{paid: overtimePaid}" @click="onOverTimePaid">
              <i v-if="adminPrivs" class="far fa-star fa-xs hidden"></i>
              <!-- &nbsp; -->
              <pretty-time :show-zero="true" :seconds="overtime" />
              <!-- &nbsp; -->
              <i v-if="adminPrivs" class="far fa-calendar-check fa-xs"></i>
            </span>
          </p>
        </div>
      </div>

      <div class="columns is-mobile" v-if="!inputsDisabled">
        <div class="column is-4">
          <button class="button is-link" @click="submit">Submit</button>
        </div>
        <div v-if="user" class="column is-8 has-text-right">
          <button :disabled="inputsDisabled"  class="button has-text-grey" @click="setDefault">Set Default</button>
          &nbsp;
          <b-dropdown position="is-top-left" :mobile-modal="false">
            <button class="button has-text-grey" slot="trigger">
              <i class="fas fa-ellipsis-h"></i>
            </button>
            <b-dropdown-item custom>
              <button class="button is-small clear-button" @click="onClear">
                Clear
              </button>
            </b-dropdown-item>
            <b-dropdown-item custom>
              <b-checkbox v-model="sickDay">Sick</b-checkbox>
            </b-dropdown-item>
            <b-dropdown-item custom>
              <b-checkbox v-model="leaveDay">Leave</b-checkbox>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div v-if="inputsDisabled && overtimePaid">
         <div class="notification is-info">
          <strong>Cannot edit hours: </strong>Overtime paid up to {{ overtimePaidDateStr }}
        </div>
      </div>

    </template>

  </div>
</template>

<style>
.edit-hours .overtime-button .fa-calendar-check {
  opacity: 0.25;
}

.edit-hours .overtime-button.paid .fa-calendar-check {
  opacity: 1;
  color: green;
}

.edit-hours .subtitle {
  margin-bottom: 5px;
}

.edit-hours .columns {
  margin-bottom: 0px;
}

.edit-hours .clear-button {
  width: 100%;
}

 .edit-hours .now {
   float: right;
   border-radius: 5px;
   background-color: #eee;
   padding: 0px 5px;
   cursor: pointer;
   /* text-transform: uppercase; */
 }

 .edit-hours .columns .column:first-child {
   padding-left: 0;
 }

 .edit-hours .columns .column:last-child {
   padding-right: 0;
 }

 .edit-hours .dropdown-menu {
  margin-bottom: 5px;
  min-width: auto;
  text-align: left;
}

.edit-hours .dropdown-menu .dropdown-content {
  padding: 0;
  background-color: #eee;
}
</style>

<script>
import PrettyTime from './PrettyTime'
import TimeInput from './TimeInput'
export default {
  name: 'EditHours',
  components: {
    PrettyTime,
    TimeInput
  },
  props: ['day', 'user', 'canSetOvertimePaid'],
  data () {
    return {
      startTimestamp: null,
      endTimestamp: null,
      hadBreak: false,
      breakMinutes: 0,
      showStartNow: false,
      showEndNow: false,
      sickDay: false,
      leaveDay: false,
      futureDay: false
    }
  },
  watch: {
    hadBreak () {
      if (this.hadBreak && !this.breakMinutes) {
        this.breakMinutes = 30
      }
    },
    sickDay () {
      if (this.sickDay && this.leaveDay) {
        this.leaveDay = false
      }
    },
    leaveDay () {
      if (this.leaveDay && this.sickDay) {
        this.sickDay = false
      }
    }
  },
  computed: {
    adminPrivs () { return this.canSetOvertimePaid && this.$store.getters.user.privileges.includes('admin') },
    workingSecondsPerDay () { return this.$store.getters.workingSecondsPerDay },
    inputsDisabled () { return this.overtimePaid && !this.adminPrivs },
    overtimePaid () { return this.user.overtimePaid > this.day.timestamp },
    isWeekend () {
      let dayOfWeek = this.$moment.unix(this.day.timestamp).format('dd')
      return dayOfWeek === 'Sa' || dayOfWeek === 'Su'
    },
    name () {
      if (this.user) {
        return `${this.user.firstName} ${this.user.lastName}`
      } else {
        return 'NO USER?'
      }
    },
    dateStr () {
      return this.$moment.unix(this.day.timestamp).format(this.dateFormat)
    },
    overtimePaidDateStr () {
      return this.$moment.unix(this.user.overtimePaid).format(this.dateFormat)
    },
    dateFormat () {
      return this.$store.getters.isPhone ? 'ddd Do MMM YYYY' : 'dddd Do MMMM YYYY'
    },
    deltaSeconds () {
      if (!this.startTimestamp || !this.endTimestamp) {
        return 0
      }

      let seconds = this.endTimestamp - this.startTimestamp
      return seconds
    },
    seconds () {
      if (this.deltaSeconds <= 0) {
        return 0
      }
      let seconds = this.deltaSeconds
      if (this.hadBreak) {
        seconds -= Number(this.breakMinutes * 60)
      }
      seconds = seconds.toFixed(0)
      return seconds
    },
    overtime () {
      if (this.deltaSeconds <= 0) {
        return 0
      }
      let seconds = this.deltaSeconds
      if (this.hadBreak) {
        seconds -= Number(this.breakMinutes * 60)
      }
      let overtime = this.isWeekend ? seconds : Math.max(0, seconds - this.workingSecondsPerDay)
      return overtime
    },
    defaultStartTime () {
      if (this.user && this.user.defaultStartTime) {
        return this.user.defaultStartTime
      } else {
        return this.$store.getters.defaultStartTime
      }
    },
    defaultEndTime () {
      if (this.user && this.user.defaultEndTime) {
        return this.user.defaultEndTime
      } else {
        return this.$store.getters.defaultEndTime
      }
    }
  },
  created () {
    if (!this.user) {
      console.error('EDIT HOURS ERROR: NO USER!!')
      return
    }
    if (!this.day) {
      console.error('EDIT HOURS ERROR: NO DAY!!')
      return
    }
    if (!this.day.timestamp) {
      console.error('EDIT HOURS ERROR: NO TIMESTAMP!!')
      return
    }

    this.sickDay = this.day.sick || false
    this.leaveDay = this.day.leave || false

    let today = this.$moment()
    if (this.day.timestamp > today.unix()) {
      this.futureDay = true
      return
    }

    this.startTimestamp = this.day.start
    this.endTimestamp = this.day.end
    this.breakMinutes = Math.floor(this.day.break / 60)
    this.hadBreak = this.breakMinutes > 0
    let date = this.$moment.unix(this.day.timestamp)
    if (this.$utils.isSameDay(date, today)) {
      let now = new Date()
      let currentHour = now.getHours()
      this.showStartNow = currentHour <= 12
      this.showEndNow = currentHour >= 12
    }
  },
  methods: {
    setDefault () {
      let dayMoment = this.$moment.unix(this.day.timestamp)
      let startMoment = this.$utils.timeStrToMoment(this.defaultStartTime, dayMoment)
      let endMoment = this.$utils.timeStrToMoment(this.defaultEndTime, dayMoment)
      if (startMoment && endMoment) {
        this.startTimestamp = startMoment.unix()
        this.endTimestamp = endMoment.unix()
        this.hadBreak = true
        this.breakMinutes = 30
      }
    },
    onOverTimePaid () {
      if (!this.adminPrivs) return
      let timestamp = this.$moment.unix(this.day.timestamp).endOf('day').unix()
      if (this.user.overtimePaid && this.user.overtimePaid === timestamp) {
        this.$dialog.confirm({
          message: `<b>${this.name} Overtime</b><br /><br />Clearing overtime paid up to.`,
          confirmText: 'Clear overtime',
          type: 'is-danger',
          onConfirm: this.clearOvertimePaid
        })
      } else {
        let message = `<b>${this.name} Overtime</b><br /><br />Set overtime paid up to<br /><b>${this.dateStr}</b>?`
        if (this.day.timestamp < this.user.overtimePaid) {
          message += `<br><br><b><span class="tag is-warning">WANRING</span><br />Overtime paid up to is already set to ${this.$moment.unix(this.user.overtimePaid).format(this.dateFormat)}</b>`
        }
        this.$dialog.confirm({
          message,
          confirmText: 'Set overtime',
          onConfirm: this.setOverTimePaid
        })
      }
    },
    onClear () {
      this.startTimestamp = 0
      this.endTimestamp = 0
      this.hadBreak = false
      this.breakMinutes = 0
      this.sickDay = false
      this.leaveDay = false
    },
    clearOvertimePaid () {
      if (!this.adminPrivs) return
      let userDoc = this.$firestore.collection('users').doc(this.user.uid)
      if (userDoc) {
        userDoc.update({ overtimePaid: 0 })
          .then(() => {
            this.user.overtimePaid = 0
            this.$toast.open({
              message: 'Overtime paid up to cleared!',
              type: 'is-info'
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast.open({
              message: 'Could not clear over time paid up to.',
              type: 'is-danger'
            })
          })
      } else {

      }
    },
    setOverTimePaid () {
      if (!this.adminPrivs) return
      let timestamp = this.$moment.unix(this.day.timestamp).endOf('day').unix()
      let userDoc = this.$firestore.collection('users').doc(this.user.uid)
      if (userDoc) {
        userDoc.update({ overtimePaid: timestamp })
          .then(() => {
            this.user.overtimePaid = timestamp
            this.$toast.open({
              message: 'Overtime paid up to updated!',
              type: 'is-info'
            })
          })
          .catch(err => {
            console.error(err)
            this.$toast.open({
              message: 'Could not set over time paid up to.',
              type: 'is-danger'
            })
          })
      } else {
        this.$toast.open({
          message: 'Could not set over time pain up to.',
          type: 'is-danger'
        })
      }
    },
    submit () {
      if (this.startTimestamp) {
        this.day.start = Number(this.startTimestamp)
        this.day.startStr = this.$moment.unix(this.startTimestamp).format('h:mma')
      } else {
        this.day.start = null
        this.day.startStr = ''
      }

      if (this.endTimestamp) {
        this.day.end = Number(this.endTimestamp)
        this.day.endStr = this.$moment.unix(this.endTimestamp).format('h:mma')
      } else {
        this.day.end = null
        this.day.endStr = ''
      }

      if (!this.hadBreak || (!this.startTimestamp && !this.endTimestamp)) {
        this.day.break = 0
      } else {
        this.day.break = Number(this.breakMinutes) * 60
      }

      this.day.sick = this.sickDay
      this.day.leave = this.leaveDay

      this.day.seconds = Number(this.seconds)
      this.day.hours = Number(Number(this.seconds) / 60 / 60).toFixed(2)
      this.day.overtime = this.overtime
      this.$emit('submit', this.day)
    },
    getNow () {
      return this.$moment().startOf('minute').unix()
    }
  }
}
</script>
